import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_APRVAPP_SRCH_COND,
    SG_APRVAPP_LST,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";

/**
 * LPCO Application Inspection List
 * !== LPCO 신청서 검사 목록 ==!
 */
export const OSCI0201009Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0007"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0121" }],
    });

    const location = useLocation();
    let menuTp: any = "";
    let errmsg: any;

    // Application LIST
    const [appCdNoList, setAppCdNoList] = useState([]);

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        handler.setInit();
    }, [location.pathname]);

    /*
     * Approval Application Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Application list search conditions !== 심사 신청서 목록 검색 조건 ==!
        newAppSrchCond: useForm({
            defaultSchema: SF_APRVAPP_SRCH_COND,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                    srchSbmsDtEnd: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Approval Application List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Approval Application List !== 심사 신청서 목록  ==!
        appLst: useGrid({
            defaultSchema: SG_APRVAPP_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_appLst: {
            head: {},
            cell: {
                appNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = {
                        menuTp: "INSC",
                        appId: rowValues.appId,
                        asnmtCfrmDtm: rowValues.asnmtCfrmDtm,
                        appStatCd: rowValues.appStatCd,
                    };
                    return (
                        <Layout direction="col" gap={1}>
                            <Link
                                to={`${URLS.osci0201010s}/${rowValues.appId}`}
                                state={param}
                            >{`${rowValues.appNo}`}</Link>
                        </Layout>
                    );
                },
                btnRcve: (props: any) => {
                    const { binding, rowValues, value } = props;
                    let bVisible = rowValues.asnmtCfrmDtm == null;
                    return (
                        bVisible &&
                        menuTp != "APP" && (
                            <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                    handler.updateReceived(rowValues.appId, rowValues.appStatCd);
                                }}
                            >
                                {t("L_RCVE_1")}
                            </Button>
                        )
                    );
                },
            },
        },
    };

    const fetch = {
        // Application List !== Application 목록 ==!
        getOrgLpcoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(auth.get("orgCd"));
            },
            onSuccess: (data) => {
                setAppCdNoList(data || []);
            },
            onError: () => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        getAppList: useFetch({
            api: (page = grid.appLst.page) => {
                return APIS.getAppList(
                    { ...form.newAppSrchCond.getValues(), srchOrgCd: auth.get("orgCd"), menuTp: "INSC" },
                    page,
                    grid.appLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.newAppSrchCond.errors) && form.newAppSrchCond.isSubmitted,
            key: [grid.appLst.page, grid.appLst.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.newAppSrchCond.getValues(),
                    srchOrgCd: auth.get("orgCd"),
                    menuTp: "INSC",
                    page: grid.appLst.page,
                    size: data.appList.page.totalSize,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                navigate(URLS.osci0201010s + "/" + param[0], { state: { menuTp: "INSC", appId: param[0] } });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
        // Get process information to check the configuration !== 프로세스 설정 확인용 정보 조회 ==!
        checkPrcsCfgn: useFetch({
            api: (appId: string) => APIS.getAppAprvInfo({ reffId: appId }),
            onError: (error: any) => {
                console.log("checkPrcsCfgn error", error);
            },
        }),
    };

    const handler = {
        setInit: async () => {
            await fetch.getOrgLpcoList.fetch();
            handler.getAppList();

            grid.appLst.setShow("column", "btnRcve", true);
        },
        // Get list of Consignment Application List !== 위탁수하물 신청서 목록 조회 ==!
        getAppList: (page: number = 0) => {
            form.newAppSrchCond.handleSubmit(async () => {
                grid.appLst.setPage(page);
                await fetch.getAppList.fetch();
            })();
        },
        // Block when the current step is missing in the process configuration !== 현재 처리단계가 프로세스 설정에 없으면 차단 ==!
        checkPrcsCfgnValid: async (appId: any): Promise<boolean> => {
            const result: any = await fetch.checkPrcsCfgn.fetch(appId);
            if (result?.prcsInfo?.content?.prcsRoleTpCd) {
                return true;
            }
            modal.openModal({ content: "msg.osc.00046" }); // Process setting error, contact the organization !== 프로세스 설정 오류, 기관 문의 ==!
            return false;
        },
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            if (!(await handler.checkPrcsCfgnValid(appId))) {
                return;
            }
            fetch.updateReceived.fetch(appId, appStatCd);
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppSrchCond.schema.srchAppNo} />
                            <Group.Control {...form.newAppSrchCond.schema.srchUcrNo} />
                        </Group.Row>

                        <Group.Row>
                            {/* <Group.Control {...form.newAppSrchCond.schema.srchTin} /> */}
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchAppCdNo}
                                options={appCdNoList}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchSbmsDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchAprvDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppSrchCond.schema.srchAppStatCd} />
                            <Group.Control {...form.newAppSrchCond.schema.srchCstmOfceCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    // form.newAppSrchCond.reset();
                                    form.newAppSrchCond.setValues({
                                        srchAppNo: null,
                                        srchUcrNo: null,
                                        srchAppCdNo: null,
                                        srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                                        srchSbmsDtEnd: comnUtils.getDate(),
                                        srchAprvDtStart: null,
                                        srchAprvDtEnd: null,
                                        srchAppStatCd: null,
                                    });
                                    handler.getAppList();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={async () => {
                                    handler.getAppList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.appLst.grid} data={fetch.getAppList.data?.appList} render={render.grid_appLst} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
